
import { Form, Slider } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import styled from 'styled-components';
import { shouldComponentBeVisible } from '../../utils/evaluateCondition';
import globalGetPadding from '../../utils/getPadding';
import { getBorderRadiusValue } from '../../utils/borderRadius';
function getFontFamily(fontFamily) {
    switch (fontFamily) {
        case 'MODERN_SANS':
            return '"Helvetica Neue", "Arial Nova", "Nimbus Sans", Arial, sans-serif';
        case 'BOOK_SANS':
            return 'Optima, Candara, "Noto Sans", source-sans-pro, sans-serif';
        case 'ORGANIC_SANS':
            return 'Seravek, "Gill Sans Nova", Ubuntu, Calibri, "DejaVu Sans", source-sans-pro, sans-serif';
        case 'GEOMETRIC_SANS':
            return 'Avenir, "Avenir Next LT Pro", Montserrat, Corbel, "URW Gothic", source-sans-pro, sans-serif';
        case 'HEAVY_SANS':
            return 'Bahnschrift, "DIN Alternate", "Franklin Gothic Medium", "Nimbus Sans Narrow", sans-serif-condensed, sans-serif';
        case 'ROUNDED_SANS':
            return 'ui-rounded, "Hiragino Maru Gothic ProN", Quicksand, Comfortaa, Manjari, "Arial Rounded MT Bold", Calibri, source-sans-pro, sans-serif';
        case 'MODERN_SERIF':
            return 'Charter, "Bitstream Charter", "Sitka Text", Cambria, serif';
        case 'BOOK_SERIF':
            return '"Iowan Old Style", "Palatino Linotype", "URW Palladio L", P052, serif';
        case 'MONOSPACE':
            return '"Nimbus Mono PS", "Courier New", "Cutive Mono", monospace';
        default:
            return undefined;
    }
}

const SliderPropsDefaults = {
    label: '',
    name: '',
    minNumber: 0,
    maxNumber: 100,
    isRange: false,
    step: '1',
    marks: [],
    sliderColor: {
        startColor: '#0F6CBD',
        endColor: '#0F6CBD'
    },
    required: false,
    visible: {
        alwaysShow: true,
        conditions: []
    },
    isFormItem: true,
    disabled: false
};

const CustomSlider = styled(Slider)`
    .ant-slider-track {
        background: ${({$startColor, $endColor})=>('linear-gradient(to right, '+$startColor+' 0%, '+$endColor+' 100%) !important')};
    }
`;

export const FormSlider = (_a)=> {
    const rootData = _a.form_data.root;
    const root_formStyle = rootData?.data?.formStyle;
    const root_formMessage = rootData?.data?.messageData;
    const isMobile = _a.formClientWidth <= 480;
    var _b, _c, _d, _e, _f, _bb, _cc, _dd, _ee;
    var style = _a.style;
    var wStyle = {
        backgroundColor: (_c = style === null || style === void 0 ? void 0 : style.backgroundColor) !== null && _c !== void 0 ? _c : undefined,
        padding: globalGetPadding(style === null || style === void 0 ? void 0 : style.padding, isMobile),
        borderRadius: getBorderRadiusValue((_f = style === null || style === void 0 ? void 0 : style.borderRadius) !== null && _f !== void 0 ? _f : undefined),
    };
    var labelStyle = {
        color: (_b = style === null || style === void 0 ? void 0 : style.color) !== null && _b !== void 0 ? _b : undefined,
        fontSize: (_d = style === null || style === void 0 ? void 0 : style?.fontSize) !== null && _d !== void 0 ? (isMobile ? _d/1.1 : _d) : undefined,
        fontFamily: getFontFamily(style === null || style === void 0 ? void 0 : style.fontFamily),
        fontWeight: (_e = style === null || style === void 0 ? void 0 : style.fontWeight) !== null && _e !== void 0 ? _e : undefined,
    }
    var marks = (_bb = style === null || style === void 0 ? void 0 : style.marks) !== null && _bb !== void 0 ? _bb : SliderPropsDefaults.marks;
    var sliderColor = (_cc = style === null || style === void 0 ? void 0 : style.sliderColor) !== null && _cc !== void 0 ? _cc : SliderPropsDefaults.sliderColor;
    // var text = (_g = props === null || props === void 0 ? void 0 : props.text) !== null && _g !== void 0 ? _g : TextPropsDefaults.text;
    // return <div style={wStyle}>
    //     {text}
    // </div>;

    var _g, _h, _i, _j, _k, _l, _m, _n;
    var props = _a.props;
    var label = (_g = props === null || props === void 0 ? void 0 : props.label) !== null && _g !== void 0 ? _g : SliderPropsDefaults.label;
    var name = (_h = props === null || props === void 0 ? void 0 : props.name) !== null && _h !== void 0 ? _h : SliderPropsDefaults.name;
    var minNumber = (_i = props === null || props === void 0 ? void 0 : props.minNumber) !== null && _i !== void 0 ? _i : SliderPropsDefaults.minNumber;
    var maxNumber = (_j = props === null || props === void 0 ? void 0 : props.maxNumber) !== null && _j !== void 0 ? _j : SliderPropsDefaults.maxNumber;
    var isRange = (_dd = props === null || props === void 0 ? void 0 : props.isRange) !== null && _dd !== void 0 ? _dd : SliderPropsDefaults.isRange;
    var step = (_m = props === null || props === void 0 ? void 0 : props.step) !== null && _m !== void 0 ? _m : SliderPropsDefaults.step;
    var required = (_k = props === null || props === void 0 ? void 0 : props.required) !== null && _k !== void 0 ? _k : SliderPropsDefaults.required;
    var visible = (_l = props === null || props === void 0 ? void 0 : props.visible) !== null && _l !== void 0 ? _l : SliderPropsDefaults.visible;
    var disabled = (_n = props === null || props === void 0 ? void 0 : props.disabled) !== null && _n !== void 0 ? _n : SliderPropsDefaults.disabled;

    const formStyle = _a.formStyle;
    const item_layout = !formStyle?.layout && root_formStyle?.layout ? root_formStyle?.layout : formStyle?.layout ? 
        formStyle?.layout : '';
    const item_colon = formStyle?.colon === undefined && root_formStyle?.colon !== undefined ? root_formStyle?.colon : formStyle?.colon;
    
    const requiredText = props?.requiredText !== null && props?.requiredText !== void 0 ? props?.requiredText : root_formMessage?.required;
    
    const [fieldHidden, setFieldHidden] = useState(false);
    const calVisible = useMemo(()=>{
        if(visible?.alwaysShow) {
            return true;
        }
        else {
            return shouldComponentBeVisible(visible?.conditions, _a?.allFieldValues);
        }
    }, [visible, _a?.allFieldValues])

    useEffect(()=>{
        if(!calVisible && _a?.formRef && !_a?.props?.hiddenOnly) {
            _a?.formRef.setFieldValue(name, undefined);
            _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                ...prevData,
                [name]: {
                    value: undefined,
                    isRequired: prevData[name]?.isRequired,
                    type: prevData[name]?.type
                }
            }))
        }
    }, [calVisible])
        
    useEffect(()=>{
        //fieldSource: 通过api获取当前组件的数据，比如option
    }, [_a?.fieldSource])

    useEffect(()=>{
        //otherCustom: 后端传的其他数据，其中有displayOnly，hidden等字段，控制组件的隐藏和只读。hidden时组件渲染但是不显示�?
        if(_a?.props?.hiddenOnly === true) {
            setFieldHidden(true);
        }
        else {
            setFieldHidden(false);
        }
    }, [_a?.props?.hiddenOnly])

    return !calVisible && !fieldHidden ? null : <div style={{...wStyle, ...fieldHidden ? {
        visibility: 'hidden',
        opacity: 0,
        height: 0,
        overflow: 'hidden',
        padding: 0,
        margin: 0,
        border: 0
    } : {}}}>
        <Form.Item
            name={name}
            label={label && label.trim() ? <span style={labelStyle}>{item_layout === 'vertical' && item_colon ? label+": " : label}</span> : undefined}
            className={(!formStyle?.labelAlign && root_formStyle?.labelAlign === 'right') || formStyle?.labelAlign === 'right' ? 
                'ant-form-item-label-right' : ''}
            layout={item_layout}
            colon={item_colon}
            rules={required ? [{ required: true, requiredText}] : []}
        >
            <CustomSlider 
                range={isRange}
                min={minNumber}
                max={maxNumber}
                disabled={disabled}
                step={step === 'null' && marks?.length ? null : (step === 'null' ? 1 : parseInt(step))}
                marks={marks?.length ? marks.reduce((acc, item) => {
                    const { key, ...rest } = item;
                    acc[key] = {
                        ...rest,
                        style: {
                            ...rest.style,
                            fontSize: isMobile&&rest.style.fontSize ? rest.style.fontSize/1.2 : rest.style.fontSize
                        }
                    };
                    return acc;
                }, {}) : {}}
                onChange={(val)=>{
                    _a.setAllFieldValues && _a.setAllFieldValues(prevData=>({
                        ...prevData,
                        [name]: {
                            value: val,
                            isRequired: prevData[name]?.isRequired,
                            type: prevData[name]?.type
                        }
                    }))
                }}
                $startColor={sliderColor.startColor}
                $endColor={sliderColor.endColor}
            />
        </Form.Item>
    </div>;
}

